import { render, staticRenderFns } from "./VideoEditLayer.vue?vue&type=template&id=025bb848&scoped=true&"
import script from "./VideoEditLayer.vue?vue&type=script&lang=js&"
export * from "./VideoEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoEditLayer.vue?vue&type=style&index=0&id=025bb848&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025bb848",
  null
  
)

export default component.exports